/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bilingual_EnglishInputs */



/**
* | output |
* | --- |
* | "Bilingual English" |
*
* @param {Bilingual_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bilingual_english = /** @type {((inputs?: Bilingual_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bilingual_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anglais bilingue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zweisprachig Englisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inglese bilingue")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двуязычный английский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inglés bilingüe")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双语英语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バイリンガル英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("द्विभाषी अंग्रेजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inglês bilíngue")
	return /** @type {LocalizedString} */ ("Bilingual English")
});